import { render, staticRenderFns } from "./TheUploadFiles.vue?vue&type=template&id=2a184560&scoped=true"
import script from "./TheUploadFiles.vue?vue&type=script&lang=js"
export * from "./TheUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./TheUploadFiles.vue?vue&type=style&index=0&id=2a184560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a184560",
  null
  
)

export default component.exports